import React from 'react';

export default () => <div>Anthony Nolan Admin Frontend</div>;
